import { z } from "zod";
import { paginationSchema } from "./pagination";

/**
 * HCA Moravia — HCA Klub (Sprint 54, §3.2).
 */

const uuidMsg = "Neplatné UUID";
const nazevField = z.string().min(1).max(200);

export const createKlubSetkaniSchema = z.object({
  datum: z.coerce.date(),
  tema: nazevField,
  popis: z.string().max(5000).optional(),
  host: z.string().max(200).optional(),
  kapacita: z.coerce.number().int().min(1).max(500).default(20),
  misto: z.string().max(500).optional(),
  aktivni: z.boolean().default(true),
});

export const updateKlubSetkaniSchema = z.object({
  id: z.string().uuid(uuidMsg),
  datum: z.coerce.date().optional(),
  tema: nazevField.optional(),
  popis: z.string().max(5000).optional(),
  host: z.string().max(200).optional(),
  kapacita: z.coerce.number().int().min(1).max(500).optional(),
  misto: z.string().max(500).optional(),
  archivVideoUrl: z.string().url().max(500).optional(),
  archivZapisMd: z.string().max(50000).optional(),
  aktivni: z.boolean().optional(),
});

export const klubSetkaniIdSchema = z.object({ id: z.string().uuid(uuidMsg) });

export const listKlubSetkaniSchema = paginationSchema.extend({
  aktivniOnly: z.coerce.boolean().optional(),
  upcomingOnly: z.coerce.boolean().optional(),
});

export const klubPrihlasitSchema = z.object({
  setkaniId: z.string().uuid(uuidMsg),
  klientId: z.string().uuid(uuidMsg),
});

export const markKlubAttendanceSchema = z.object({
  setkaniId: z.string().uuid(uuidMsg),
  klientId: z.string().uuid(uuidMsg),
  pritomen: z.boolean(),
});

export const addKlubMemberSchema = z.object({
  klientId: z.string().uuid(uuidMsg),
});
